import { PagedItems } from '@texas/types';
import { httpClient } from '../httpClient/httpClient';

export enum UserProfileType {
  KeyAccountManager = 1,
}

export interface UserProfile {
  name: string;
  id: number;
  type: UserProfileType;
  userId: number;
  archived?: Date;
  connectedProjectsCount: number;
}

export interface CreateUserProfileRequest {
  name: string;
  userId: number;
  type: UserProfileType;
}
export interface UpdateUserProfileRequest {
  name: string;
  userId: number;
  type: UserProfileType;
}

export interface UserProfileProjectAssignment {
  id: number;
  name: string;
  erpId: string | null;
  customerId: number;
  customerName: string;
  customerIdentifier: string | null;
  countryCode: string | null;
  archived: string | null;
}

export const userProfilesApi = {
  getProjectAssignments: (
    userId: number,
    profileId: number,
    page: number,
    pageSize: number,
  ) =>
    httpClient.get<PagedItems<UserProfileProjectAssignment>>(
      `users/${userId}/profiles/${profileId}/project-assignments`,
      { params: { page, pageSize } },
    ),
  exportProjectAssignments: (userId: number, profileId: number) =>
    httpClient.post<Blob>(
      `users/${userId}/profiles/${profileId}/project-assignments/export`,
      {
        responseType: 'blob',
      },
    ),
  createUserProfile: (request: CreateUserProfileRequest) =>
    httpClient.post<UserProfile>('userprofiles', { data: request }),
  updateUserProfile: (profileId: number, request: UpdateUserProfileRequest) =>
    httpClient.put<UserProfile>(`userprofiles/${profileId}`, {
      data: request,
    }),
  archiveUserProfile: (profileId: number) =>
    httpClient.put<UserProfile>(`userprofiles/${profileId}/archive`),
  restoreUserProfile: (profileId: number) =>
    httpClient.put<UserProfile>(`userprofiles/${profileId}/restore`),
  mergeUserProfile: (sourceProfileId: number, targetProfileId: number) =>
    httpClient.put<UserProfile>(
      `userprofiles/${sourceProfileId}/merge/${targetProfileId}`,
    ),

  getUserProfilesFromUser: (userId: number, includeArchived: boolean) =>
    httpClient.get<UserProfile[]>(`userprofiles/${userId}/${includeArchived}`),
  getUserProfilesWithType: (type: UserProfileType, includeArchived: boolean) =>
    httpClient.get<UserProfile[]>(
      `userprofiles/type/${type}/${includeArchived}`,
    ),
};
